<core-background-player
  class="background-player"
/>
